"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks if browser globals (like `window`) exist in the current environment.
 * This determines whether or not the application is being run on the client or
 * the server.
 */
function isServerSideRendering() {
    try {
        return typeof window === 'undefined';
    }
    catch (e) {
        return true;
    }
}
exports.default = isServerSideRendering;
//# sourceMappingURL=isServerSideRendering.js.map